import React from 'react';
import { SelectOptionType, ResultBall, ICustomError } from 'types';
import { errorMessages } from 'constants/common';
import { Popup } from '../Popup/Popup';
import { SelectResult } from '../SelectResult';
import { ConfirmButton, SelectWrapper, Subtitle } from './styles';
import { ErrorMessage } from '../PopupVerification/styles';

export interface IProps {
  options: SelectOptionType<ResultBall>[];
  value: ResultBall | undefined;
  loading: boolean;
  onChange: (value: ResultBall) => void;
  onConfirmClick: () => void;
  onClose: () => void;
  error?: ICustomError;
}

export const PopupChangeResultComponent = ({
  options,
  value,
  loading,
  onChange,
  onConfirmClick,
  onClose,
  error,
}: IProps) => (
  <Popup title="Change result" onClose={onClose} loading={loading}>
    <Subtitle>Color ball</Subtitle>
    <SelectWrapper>
      <SelectResult options={options} value={value} onChange={onChange} />
    </SelectWrapper>
    {error?.status === 601 ? <ErrorMessage>{errorMessages.NotAvailableAction}</ErrorMessage> : null}
    <ConfirmButton disabled={value === undefined} loading={loading} onClick={onConfirmClick}>
      Confirm
    </ConfirmButton>
  </Popup>
);
